/**
 * Custom Site Specific Javascript 
 * 
 * This file is to add custom features to the website without having to modify 
 * core/common assets. Define a custom class, and build new or overwrite 
 * existing methods to create custom functionality. Below is an example.
 */

/** Import the SubmitClaim class */
// import { ImportantDates, Page } from "../../../common/assets/js/classes";
import { ImportantDates } from "commonAssets/components/ImportantDates";
import { Page } from "commonAssets/pages/Page";
import { appLocale, outputDiv, i18n, userLanguage, siteInfo } from "../../../common/assets/js/constants";
import { createElement, loadingGif, toggleFieldError, validateField, modal, clearMessage } from "../../../common/assets/js/helpers";
// import { SubmitClaim } from "../../../common/assets/js/submit-claim";
import { SubmitClaim } from "commonAssets/components/Forms/SubmitClaim";

// Extracted the customSubmitClaim function to another file.
import { customSubmitClaim } from "./customSubmitClaim";
import { customPage } from "./customPage";
import { customImptDates } from "./customImptDates";

export { customSubmitClaim };
export { customPage };
export { customImptDates };

export function customInit(claim) {

    console.log("customInit...")

    /**
     * Because of the two claim forms, we're having to use many `if` operators.
     */

    // Contact Information
    // The first field, in consumer it's first name, on 3rd party, it's comp/health plan
    const divContactField_0 = document.getElementById("divContactField_0");
    // Asks the same question in the claim fields
    const text_1686506318411_0_2 = document.querySelector('input[name="text-1686506318411-0"]');
    // The logic for this section.
    if (this.claimFormSlug === 'claim-form-3rd-party' && divContactField_0 && text_1686506318411_0_2) {
        // Make the field 12 col wide
        divContactField_0.classList.remove('col');
        divContactField_0.classList.add('col-md-12');
        // Disable the Section A field
        text_1686506318411_0_2.disabled = true;
        divContactField_0.addEventListener('input', (input) => {
            // console.log(input.target.value)
            text_1686506318411_0_2.value = input.target.value;
        })
    }

    // Force numerical values on the below params.
    // const _consumer_totalAmount = document.getElementById("text-1686258809513-0_7");
    const _consumer_totalAmount = document.querySelector('input[name="text-1686258809513-0"]');
    if (_consumer_totalAmount) {
        _consumer_totalAmount.setAttribute("placeholder", "$ USD");
        _consumer_totalAmount.addEventListener('input', (e) => {
            forceNumber(_consumer_totalAmount)
        })
    }

    // const _3rdp_totalAmount = document.getElementById("text-1686258809513-0_18");
    const _3rdp_totalAmount = document.querySelector('input[name="text-1686258809513-0"]');
    if (_3rdp_totalAmount) {
        _3rdp_totalAmount.setAttribute("placeholder", "$ USD");
        _3rdp_totalAmount.addEventListener('input', (e) => {
            forceNumber(_3rdp_totalAmount)
        })
    }

    // Other (Explain) Checkboxes
    const _3rdp_otherExplainText = document.querySelector('input[name="text-1686506318105-0"]');
    if (_3rdp_otherExplainText) {
        _3rdp_otherExplainText.disabled = true;
    }

    // const _3rdp_otherExplainCheck = document.getElementById("checkbox-group-1686506661865-0_3");
    const _3rdp_otherExplainCheck = document.querySelector('input[name="checkbox-group-other-explain"]');
    if (_3rdp_otherExplainCheck) {
        _3rdp_otherExplainCheck.addEventListener('change', (e) => {
            if (_3rdp_otherExplainCheck.checked === true) {
                _3rdp_otherExplainText.disabled = false;
            }
            else {
                _3rdp_otherExplainText.disabled = true;
                _3rdp_otherExplainText.value = ``;
            }
        })
    }

    // const _3rdp_otherSectBText = document.getElementById("text-1686507371957-0_11");
    const _3rdp_otherSectBText = document.querySelector('input[name="text-1686507371957-0"]');
    if (_3rdp_otherSectBText) {
        _3rdp_otherSectBText.disabled = true;
    }
    // const _3rdp_otherSectBCheck = document.getElementById("checkbox-group-1686507120093-0_2");
    const _3rdp_otherSectBCheck = document.querySelector('input[name="checkbox-group-1686507120093-0"]');
    if (_3rdp_otherSectBCheck) {
        _3rdp_otherSectBCheck.addEventListener('change', () => {
            if (_3rdp_otherSectBCheck.checked === true) {
                _3rdp_otherSectBText.disabled = false;
            }
            else {
                _3rdp_otherSectBText.disabled = true;
                _3rdp_otherSectBText.value = ``;
            }
        })
    }

    // Disable Section A or B respectively and the transactional tables.
    const _3rdp_section_a = document.querySelectorAll("#text-1686506318411-0_2, #text-1686506318312-0_3, input[name='checkbox-group-1686506661865-0'],  #transactions_1 input");
    const _transactionalButtonA = document.getElementById('add_transactions_1');

    const _3rdp_section_b = document.querySelectorAll("#text-1686508578596-0_12, #text-1686508626215-0_13, input[name='checkbox-group-1686507120093-0'], #transactions_2 input");
    const _transactionalButtonB = document.getElementById('add_transactions_2');

    // Checkbox logic
    checkboxesLogic();

    // Section A Select
    _3rdp_section_a.forEach((field) => {
        field.addEventListener('input', (e) => {
            if (field.value.length > 0) {
                _3rdp_section_b.forEach((input) => {
                    input.disabled = true;
                    _transactionalButtonB.classList.add('disabled');
                    _transactionalButtonB.classList.add('btn-secondary');
                    _transactionalButtonB.classList.remove('btn-primary');
                    _transactionalButtonB.removeAttribute('tableid');
                });
            }
            else {
                _3rdp_section_b.forEach((input) => {
                    input.disabled = false;
                    _transactionalButtonB.classList.remove('disabled');
                    _transactionalButtonB.classList.remove('btn-secondary');
                    _transactionalButtonB.classList.add('btn-primary');
                    _transactionalButtonB.setAttribute('tableid', 2);
                });
            }
        })
    })

    // Section B Select
    _3rdp_section_b.forEach((field) => {
        field.addEventListener('input', (e) => {
            if (field.value.length > 0) {
                _3rdp_section_a.forEach((input) => {
                    input.disabled = true;
                    _transactionalButtonA.classList.add('disabled');
                    _transactionalButtonA.classList.add('btn-secondary');
                    _transactionalButtonA.classList.remove('btn-primary');
                    _transactionalButtonA.removeAttribute('tableid');
                });
            }
            else {
                _3rdp_section_a.forEach((input) => {
                    input.disabled = false;
                    _transactionalButtonA.classList.remove('disabled');
                    _transactionalButtonA.classList.remove('btn-secondary');
                    _transactionalButtonA.classList.add('btn-primary');
                    _transactionalButtonA.setAttribute('tableid', 2);
                });
            }
        })
    })

    // Forces required fields on the #2 transactional table
    const transactions_2 = document.getElementById('transactions_2');
    let rowID = 1;
    const transactionalBtnClick = () => {
        let inputs_2 = transactions_2.querySelectorAll(`tbody input[item-id="${rowID}"]`);
        inputs_2.forEach((input) => {
            input.addEventListener('change', (e) => {
                requireRow(e.target.parentElement.parentElement.parentElement, e.target.value);
            });
        });
        rowID++;
    };
    if (transactions_2) {
        transactionalBtnClick();
    }

    const add_transactions_2 = document.getElementById('add_transactions_2');
    if (add_transactions_2) {
        add_transactions_2.addEventListener('click', function () {
            transactionalBtnClick();
        })
    }

    /**
     * Deficiency Portal Updates
     * 
     * @description Deficiency Portal Updates
     * @since 2025.03.26
     * @version 2025.03.26
     */
    document.querySelector("#transactions").querySelectorAll("input").forEach((input) => { input.disabled = true; });
    document.querySelector("#transactions").classList.add("disabled", "d-none");

    return claim;
}

export function customProcess(claim) {

    console.log("customProcess...")

    /**
     * JSB Conversion Pixels
     */
    switch (this.claimFormSlug) {
        case 'claim-form-consumer':
            consumerClaimCompletionPixel();
            break;

        case 'claim-form-3rd-party':
            thirdPartyClaimCompletionPixel();
            break;

        default:
            break;
    }

    return claim;
}

function forceNumber(params) {
    const inputValue = params.value;

    // Remove any non-digit characters
    const sanitizedValue = inputValue.replace(/\D/g, '');

    // Update the input value with the sanitized value
    params.value = sanitizedValue;
}

function requireRow(row, toggle) {
    if (toggle) {
        [].forEach.call(row.querySelectorAll('input, select, textarea'), function (input) {
            toggleRequiredField(input, true);
            validateField(input);
        });
    } else {
        var empty = true;
        [].forEach.call(row.querySelectorAll('input, select, textarea'), function (input) {
            if (input.value) {
                empty = false;
            }
        });
        if (empty) {
            [].forEach.call(row.querySelectorAll('input, select'), function (input) {
                toggleRequiredField(input, false);
                toggleFieldError(input, false);
            });
        } else {
            [].forEach.call(row.querySelectorAll('input, select, textarea'), function (input) {
                if (!input.value) {
                    toggleRequiredField(input, true);
                    validateField(input);
                }
            });
        }
    }
}

function toggleRequiredField(field, toggle) {
    var validation = field.getAttribute('data-validate').split(' ');

    if (toggle) {
        field.addEventListener('change', validateField);
        if (validation.indexOf('required') == -1) {
            validation.push('required');
        }
    } else {
        field.removeEventListener('change', validateField);

        var index = validation.indexOf('required');
        if (index != -1) {
            validation.splice(index, 1);
        }
    }

    field.setAttribute('data-validate', validation.join(' '));
}

function checkboxesLogic() {
    // Get all the checkboxes in the group
    let checkboxes = document.querySelectorAll('input[type="checkbox"]');

    if (checkboxes) {
        // Add event listener to each checkbox
        checkboxes.forEach(function (checkbox) {
            checkbox.addEventListener('change', function () {
                // Uncheck all checkboxes in the group
                checkboxes.forEach(function (cb) {
                    if (cb !== checkbox) {
                        cb.checked = false;
                    }
                });
            });
        });
    }
}

/**
 * Pixel should be placed on the form start page to track users who begin 
 * the form fill.
 */
export function consumerClaimPagePixel() {
    (function () {
        var w = window, d = document;
        var s = d.createElement('script');
        s.setAttribute('async', 'true');
        s.setAttribute('type', 'text/javascript');
        s.setAttribute('src', '//c1.rfihub.net/js/tc.min.js');
        var f = d.getElementsByTagName('script')[0];
        f.parentNode.insertBefore(s, f);
        if (typeof w['_rfi'] !== 'function') {
            w['_rfi'] = function () {
                w['_rfi'].commands = w['_rfi'].commands || [];
                w['_rfi'].commands.push(arguments);
            };
        }
        _rfi('setArgs', 'ver', '9');
        _rfi('setArgs', 'rb', '46371');
        _rfi('setArgs', 'ca', '20848107');
        _rfi('setArgs', '_o', '46371');
        _rfi('setArgs', '_t', '20848107');
        _rfi('track');
    })();
}

/**
 * Pixel should be placed on the final form submit (successful submit) or the 
 * thank you page to track users who have completed the form. Usually the 
 * thank you page option is easiest.
 */
function consumerClaimCompletionPixel() {
    (function () {
        var w = window, d = document;
        var s = d.createElement('script');
        s.setAttribute('async', 'true');
        s.setAttribute('type', 'text/javascript');
        s.setAttribute('src', '//c1.rfihub.net/js/tc.min.js');
        var f = d.getElementsByTagName('script')[0];
        f.parentNode.insertBefore(s, f);
        if (typeof w['_rfi'] !== 'function') {
            w['_rfi'] = function () {
                w['_rfi'].commands = w['_rfi'].commands || [];
                w['_rfi'].commands.push(arguments);
            };
        }
        _rfi('setArgs', 'ver', '9');
        _rfi('setArgs', 'rb', '46371');
        _rfi('setArgs', 'ca', '20848108');
        _rfi('setArgs', '_o', '46371');
        _rfi('setArgs', '_t', '20848108');
        _rfi('track');
    })();
}

/**
 * Pixel should be placed on the form start page to track users who 
 * begin the form fill.
 */
export function thirdParyClaimPagePixel() {
    (function () {
        var w = window, d = document;
        var s = d.createElement('script');
        s.setAttribute('async', 'true');
        s.setAttribute('type', 'text/javascript');
        s.setAttribute('src', '//c1.rfihub.net/js/tc.min.js');
        var f = d.getElementsByTagName('script')[0];
        f.parentNode.insertBefore(s, f);
        if (typeof w['_rfi'] !== 'function') {
            w['_rfi'] = function () {
                w['_rfi'].commands = w['_rfi'].commands || [];
                w['_rfi'].commands.push(arguments);
            };
        }
        _rfi('setArgs', 'ver', '9');
        _rfi('setArgs', 'rb', '46371');
        _rfi('setArgs', 'ca', '20848109');
        _rfi('setArgs', '_o', '46371');
        _rfi('setArgs', '_t', '20848109');
        _rfi('track');
    })();
}

/**
 * Pixel should be placed on the final form submit (successful submit) or the 
 * thank you page to track users who have completed the form. Usually the 
 * thank you page option is easiest.
 */
function thirdPartyClaimCompletionPixel() {
    (function () {
        var w = window, d = document;
        var s = d.createElement('script');
        s.setAttribute('async', 'true');
        s.setAttribute('type', 'text/javascript');
        s.setAttribute('src', '//c1.rfihub.net/js/tc.min.js');
        var f = d.getElementsByTagName('script')[0];
        f.parentNode.insertBefore(s, f);
        if (typeof w['_rfi'] !== 'function') {
            w['_rfi'] = function () {
                w['_rfi'].commands = w['_rfi'].commands || [];
                w['_rfi'].commands.push(arguments);
            };
        }
        _rfi('setArgs', 'ver', '9');
        _rfi('setArgs', 'rb', '46371');
        _rfi('setArgs', 'ca', '20848110');
        _rfi('setArgs', '_o', '46371');
        _rfi('setArgs', '_t', '20848110');
        _rfi('track');
    })();
}
